import { gql } from '@apollo/client';

export const GET_CALENDAR_AUTOCOMPLETE = gql`
  query calendar {
    v1_general_trips(prm: { calendar: true }) {
      id
      name
      partner_id
      partner_name
      comission
    }
  }
`;

export const GET_PRODUCTS_AUTOCOMPLETE = gql`
  query v1_general_trips {
    v1_general_trips {
      id
      name
      city_id
      city_id2
      city_id3
      city_id4
      city_id5
      city_id6
      activity_id
      activity2_id
      activity3_id
    }
  }
`;
